import React, { useState } from 'react';
import { Box } from '@mui/material';
import styles from '../../../styles/component.module.scss';
import PageHeader from '../../Header/PageHeader';
import TabView from '../../tabView/TabView';
import OrganisationRole from './OrganisationRole';
import ProjectRole from './ProjectRole';
import { useSelector } from 'react-redux';

const Roles = () => {

  const activePage = useSelector((state) => state.navigation.activePage);
  const tabsData = [
    {
      name: 'Organization Roles',
      component: <OrganisationRole />
    },
    {
      name: 'Project Roles',
      component: <ProjectRole />
    }
  ];

  const breadcrumbItems = [
    { label: 'Administration' },
    { label: activePage}
  ];

  return (
    <Box className={styles['page-container']}>
      <PageHeader
        projectName={null}
        title="Roles"
        description="Manage organization and project roles."
        activePage="Roles"
        breadcrumbItems={breadcrumbItems}
        actions={[]}
      />
      <Box sx={{ width: '100%', paddingX: 2, paddingTop: 0 }} className={styles['cover-container-col']}>
        <TabView 
          tabsData={tabsData} 
        />
      </Box>
    </Box>
  );
};

export default Roles;
